module.exports = __webpack_public_path__ + "media/src/assets/images/clients-stars-56779d56f036813041109819087b6282.svg";